// frontend/src/features/bapb/modals/IncomeApproachCompareColumn.jsx
import React, { useMemo } from "react";
import { INCOME_FIELD_DEFS, resolveIncomeCompareValue } from "./incomeApproachCatalog";

export default function IncomeApproachCompareColumn({ approach, draftSection }) {
  const inner = useMemo(() => {
    const sec = draftSection || {};
    return sec?.[approach.dataKey] || {};
  }, [draftSection, approach.dataKey]);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 border-b bg-slate-50">
        <div className="text-sm font-semibold text-slate-800">{approach.label}</div>
        <div className="text-[11px] text-slate-500">{approach.type}</div>
      </div>

      <div className="p-4 space-y-3">
        {INCOME_FIELD_DEFS.map((f) => {
          const v = resolveIncomeCompareValue(inner, f.key);
          return (
            <div key={f.key} className="rounded-xl border border-slate-100 px-3 py-2">
              <div className="text-[11px] text-slate-500">{f.label}</div>
              <div className="text-sm font-semibold text-slate-900">{String(v || "—")}</div>
            </div>
          );
        })}

        {/* Notes (not in defs, but useful) */}
        <div className="rounded-xl border border-slate-100 px-3 py-2">
          <div className="text-[11px] text-slate-500">Notes</div>
          <div className="text-sm text-slate-800 whitespace-pre-wrap">
            {String(inner?.notes || "—")}
          </div>
        </div>
      </div>
    </div>
  );
}